import { FC } from 'react'
import { Route as BrowserRoute, Redirect } from 'react-router-dom'
import { useAppSelector } from '../../redux'
import { ROUTES } from '../../utils'

type Props = {
  authOnly?: boolean
} & BrowserRoute['props']

const Route: FC<Props> = ({ authOnly, ...rest }) => {
  const { user } = useAppSelector((state) => state.user)

  // if (authOnly && !user?.id) {
  //   return <Redirect to={ROUTES.home} />
  // }

  return <BrowserRoute {...rest} />
}

export default Route
